import { Flex } from '@chakra-ui/react';

import { EditIcon, TrashIcon } from 'Asset/icon';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import { Condition } from 'Component/others';
import ButtonOutline from 'UiKit/button/buttonOutline';

import useOpenDeleteModal from 'View/studio/hooks/useOpenDeleteModal';
import { useStudioState } from 'View/studio/state';

const ActionButton = ({ values }) => {
  const { updateState } = useStudioState();
  const { onOpenDeleteModal } = useOpenDeleteModal();

  const accessPermission = getMenuPermissions('master-data', 'studio');

  return (
    <Flex gap="10px">
      <Condition statement={accessPermission?.isCanEdit}>
        <ButtonOutline borderWidth="1.5px" width="34px" height="34px" onClick={() => updateState({ isOpenFormUpsert: true, selectedStudio: values })}>
          <EditIcon color="var(--color-info70)" />
        </ButtonOutline>
      </Condition>

      <Condition statement={accessPermission?.isCanDelete}>
        <ButtonOutline borderWidth="1.5px" color="var(--color-error50)" width="34px" height="34px" onClick={() => onOpenDeleteModal(values?.id)}>
          <TrashIcon color="var(--color-error50)" />
        </ButtonOutline>
      </Condition>
    </Flex>
  );
};

export default ActionButton;
